import {FormSectionType} from '../../../../../blocks/FormBlock'

const takeAwayData: FormSectionType = {
	id: 4,
	parent_id: 2,
	channel: 'section',
	label: 'Afhaalgegevens',
	fields: [
		{
			id: 1,
			parent_id: 4,
			channel: 'text',
			name: 'tekst',
			text:
				'<p>Je kan jouw bestelling afhalen op een regionale dienst naar keuze.<br /><strong>Let op:</strong> je moet telefonisch een afspraak maken om jouw bestelling op te halen.</p>'
		},
		{
			id: 2,
			parent_id: 4,
			channel: 'select',
			name: 'afhalen',
			label: 'Afhalen',
			required: true,
			options: [
				{
					path: 'antwerpen',
					title: 'Regiodienst Antwerpen'
				}
			]
		},
		{
			id: 3,
			parent_id: 4,
			channel: 'text',
			name: 'telefoonnummer',
			text: '<p>Telefoonnummer:&nbsp;&nbsp;{phone}</p>'
		},
		{
			id: 4,
			parent_id: 4,
			channel: 'select',
			name: 'lanceermoment',
			label: 'Lanceermoment',
			required: true,
			options: [
				{
					path: '25/07/2020',
					title: '25/07/2020'
				}
			]
		},
		{
			id: 5,
			parent_id: 4,
			channel: 'checkbox',
			name: 'delivery',
			label: 'Ik laat liever gratis leveren met de post.',
			mod: 'maxwidth',
			required: false
		}
	]
}

export default takeAwayData
